export function getPowerAssetsGroupLabel(count, location, width) {
  if (width > 75) {
    return `${count} in ${location}`;
  }

  if (width > 50) {
    return `${count};${location}`;
  }

  return `${count}`;
}
